import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "../../constants/contact";

export function StickyBar() {
  return (
    <div
      data-testid="sticky-contact-bar"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-[#1B4D3E] text-[#F6F5F2] font-sans px-6 py-3 shadow-2xl border border-[#A3B18A]/40 flex items-center gap-4 text-xs font-bold uppercase tracking-wider"
    >
      <span className="hidden sm:inline">Alberto Rameni</span>
      <span className="text-[#A3B18A] hidden sm:inline">·</span>
      <a href={PHONE_TEL} data-testid="sticky-call-link" className="hover:underline">
        {PHONE_DISPLAY}
      </a>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-button"
        className="px-3 py-1 bg-[#25D366] text-white hover:bg-[#20ba5a] transition-colors"
      >
        WhatsApp
      </a>
    </div>
  );
}
